'use client';
import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { mapModifiers } from '@/utils/funtion';
import Link from 'next/link';
import { useData } from '@/stores/context';
import AntImage from '@/components/atoms/image';
import fallback from '@/assets/images/contest-banner.png';

interface IProps {
  banners: any;
}

export default function Banners(props: IProps) {
  const { banners } = props;
  const { innerWidth } = useData();
  const swiperRef = useRef<any>(null);

  return !banners?.length ? null : (
    <div className="t-banner-slides">
      <div className="t-banner-slides_swiper">
        {banners?.length > 1 && (
          <div className="t-banner-slides_swiper_nav">
            <div
              onClick={() => swiperRef?.current?.swiper.slidePrev()}
              className={mapModifiers(
                't-banner-slides_swiper_nav_prev t-banner-slides_swiper_nav_btn',
              )}
            >
              <FiChevronLeft />
            </div>
            <div
              onClick={() => swiperRef?.current?.swiper.slideNext()}
              className={mapModifiers(
                't-banner-slides_swiper_nav_next t-banner-slides_swiper_nav_btn',
              )}
            >
              <FiChevronRight />
            </div>
          </div>
        )}

        <Swiper
          ref={swiperRef}
          grabCursor={true}
          slidesPerView={1}
          spaceBetween={0}
          speed={800}
          loop={true}
          autoplay={{
            delay: 3000,
            // disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
        >
          {banners?.map((item: any) => (
            <SwiperSlide key={item.id}>
              <Link
                href="/tin-tuc/du-lieu-tuong-lai-–-sang-tao-du-doan-xu-huong/0"
                target="_blank"
              >
                <img
                  alt={`${item?.banner}`}
                  src={
                    `${process.env.NEXT_PUBLIC_BANNER + (innerWidth > 800 ? item?.banner_web : item?.banner_mobile)}` ||
                    '/'
                  }
                  // width={3500}
                  // height={2400}
                  onError={(e: any) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = fallback.src || fallback; // fallback nếu ảnh lỗi
                  }}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
